module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/label_featured.42c82.png";